module.exports = __webpack_public_path__ + "media/images/240_120_C-b8c94755d17bb69bef5981ec352b48cb.png";